import Vue from 'vue'
import { Storage } from '@capacitor/storage'

import { notifyGraphqlError } from '@/mixins/handleGraphqlError'

import { PinCodeTokenGQL } from '@/graphql/queries'
import { LoginByPinCodeGQL } from '@/graphql/mutations'

export const pinTokenKey = 'pinToken'
export const pinTokenAttemptsKey = 'pinTokenAttempts'
export const merchantSlugKey = 'merchantSlug'

export const state = Vue.observable({
  pinToken: null,
  pinTokenAttempts: 0
})

Storage.get({
  key: pinTokenKey
}).then(res => {
  state.pinToken = res.value
})

Storage.get({
  key: pinTokenAttemptsKey
}).then(res => {
  state.pinTokenAttempts = +res.value
})

export const setPinToken = {
  mixins: [notifyGraphqlError],

  methods: {
    async setPinToken ({ slug, password, pin }) {
      try {
        const { data } = await this.$apollo.query({
          query: PinCodeTokenGQL,
          variables: {
            params: {
              slug,
              password,
              pin
            }
          },
          fetchPolicy: 'network-only'
        })

        await Storage.set({
          key: pinTokenKey,
          value: data.pinCodeToken
        })

        await Storage.set({
          key: pinTokenAttemptsKey,
          value: 0
        })
      } catch (e) {
        this.notifyGraphqlError(e)
      }
    }
  }
}

export const removePinToken = {
  methods: {
    async removePinToken () {
      await Storage.remove({
        key: pinTokenKey
      })

      await Storage.remove({
        key: pinTokenAttemptsKey
      })

      await Storage.remove({
        key: merchantSlugKey
      })

      state.pinToken = null
      state.pinTokenAttempts = 0
    }
  }
}

export const getPinToken = {
  methods: {
    async getPinToken () {
      return Storage.get({
        key: pinTokenKey
      }).then(res => res.value)
    }
  }
}

export const hasPinToken = {
  computed: {
    hasPinToken () {
      return state.pinToken
    }
  }
}

export const pinTokenAttempts = {
  computed: {
    pinTokenAttempts () {
      return state.pinTokenAttempts
    }
  }
}

export const setMerchantSlug = {
  methods: {
    async setMerchantSlug (slug) {
      await Storage.set({
        key: merchantSlugKey,
        value: slug
      })
    }
  }
}

export const merchantSlug = {
  data () {
    return {
      merchantSlug: null
    }
  },

  async mounted () {
    this.merchantSlug = await Storage.get({
      key: merchantSlugKey
    }).then(res => res.value)
  }
}

export const loginByPinCode = {
  mixins: [notifyGraphqlError, removePinToken],

  methods: {
    async loginByPinCode (pin, reCaptcha) {
      const token = state.pinToken

      try {
        const { data } = await this.$apollo.mutate({
          mutation: LoginByPinCodeGQL,
          variables: {
            credentials: {
              pin,
              token,
              reCaptcha
            }
          }
        })

        state.pinTokenAttempts = 0
        return data.loginByPinCode
      } catch (e) {
        const errors = e.graphQLErrors

        if (!Array.isArray(errors)) {
          this.notifyGraphqlError(e)
        } else {
          for (const err of errors) {
            const code = err.message

            if (code === 'signature is invalid') {
              state.pinTokenAttempts++
            } else if (code === 'Unauthorized') {
              this.$notify({
                type: 'error',
                message: this.$i18n.t('errors.codes.loginOrPasswordIncorrect'),
                delay: 150,
                timeout: 3000
              })
            } else {
              const code = errors.message
              if (code === 'signature is invalid') {
                state.pinTokenAttempts++
                this.$notify({
                  type: 'error',
                  message: this.$i18n.t('errors.codes.loginOrPasswordIncorrect'),
                  delay: 150,
                  timeout: 3000
                })
              } else {
                this.notifyGraphqlError(e)
              }
            }
          }
        }
      }
    }
  }
}
